import { PageController } from '@client/components/_core/layout/PageController';
import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import logo from '@client/resources/images/logo.svg';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/')({
    component: LandingPage,
});

function LandingPage() {
    const navigate = useNavigate();

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const reason = searchParams.get('reason');

        if (reason === 'logout') {
            navigate({
                to: '/login',
            });
        }
    }, []);

    return (
        <PageController route={Route}>
            <div className="landing-page relative min-h-screen w-full overflow-hidden">
                <div className="landing-page-overlay absolute inset-0">
                    <div className="landing-page-overlay-1 absolute inset-0 -skew-y-12 transform"></div>
                    <div className="landing-page-overlay-2 absolute inset-0 skew-y-12 transform"></div>
                </div>
                <Button.Link
                    variant="primary"
                    size="large"
                    className="absolute top-6 right-6 z-10 transform rounded-lg bg-gradient-to-r from-accent-500 to-accent-600 px-8 py-3 font-semibold text-white shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:from-accent-600 hover:to-accent-700 hover:shadow-xl"
                    to="/login"
                >
                    Log in
                </Button.Link>

                <img
                    src={logo}
                    alt="Logo"
                    className="landing-page-logo absolute inset-1/2 w-74 -translate-x-1/2 -translate-y-1/2 transform"
                />
            </div>
        </PageController>
    );
}
